import { render } from "./LottieEditorCmp.vue?vue&type=template&id=ba6d3cb0"
import script from "./LottieEditorCmp.vue?vue&type=script&lang=js"
export * from "./LottieEditorCmp.vue?vue&type=script&lang=js"

import "./LottieEditorCmp.vue?vue&type=style&index=0&id=ba6d3cb0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__